<template>
	<inline-dialog
		:title="title"
		class="vueDialog"
		dialog-class="notarizationRemoveDocument sideBySide"
		state="showRemoveDialog"
		:hide-close-button="true"
	>
		<p>
			{{ body }}
		</p>
		<template #buttons="{ closeDialog }">
			<a class="largeActiveButton btn-left" @click="removeDocument(documentToRemove);closeDialog()">{{ confirmButtonLabel }}</a>
			<a class="largeInactiveButton btn-right" @click="closeDialog" @mousedown="stopRemove();">Cancel</a>
		</template>
	</inline-dialog>
</template>
<script>
import { mapActions, mapState } from "vuex";
import InlineDialog from "../../components/ui/InlineDialog.vue";

export default {
	components: { InlineDialog },
	computed: {
		isExisting() {
			return (
				this.documentToRemove?.originalDataId !== null || 
				(this.documentToRemove?.workingFileId !==
					this.documentToRemove?.originalFileId)
			);
		},
		title() {
			return this.isExisting ? `Remove Your Document` : `Delete Your Document`;
		},
		body() {
			return this.isExisting
				? `Are you sure you want to remove your ${this.documentToRemove?.fileName}? You will still be able to access your document through My Documents.`
				: `Are you sure you want to delete your ${this.documentToRemove?.fileName}? You will not be able to access your document once it is deleted.`;
		},
		confirmButtonLabel() {
			return this.isExisting ? `Remove File` : `Delete File`;
		},
		...mapState([`documentToRemove`]),
	},
	methods: {
		stopRemove() {
			this.documentToRemove.status = `done`;
			this.documentToRemove.message = `Uploaded`;
		},
		...mapActions([`removeDocument`]),
	},
};
</script>